import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { sideBarNavigation } from "../../../utility/Constant";
import NestedSideButton from "../sideBar/NestedSideButton";
import "./NavBar.css";

const NavBar = ({ user }) => {
  const { role, firstName } = user;
  const navigate = useNavigate();
  const images = [
    "https://static.vecteezy.com/system/resources/previews/002/025/839/non_2x/illustration-of-engineer-icon-with-cogwheel-free-vector.jpg",
    "https://media.istockphoto.com/id/1187828049/vector/writing-hand-glyph-icon.jpg?s=612x612&w=0&k=20&c=bsIPDKXPM85N4f2XCuwil3FITKOc9zG4EnHsUOIFpLU=",
    "https://i.ibb.co/bKrrC5x/viewer.png",
  ];
  const handleSignOut = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <div className="navbar sticky top-0 z-10  bg-[#2D3B42] py-2  lg:px-20">
      <div className="navbar-start">
        <div className="dropdown ">
          <label tabIndex={0} className="btn btn-ghost btn-circle text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h7"
              />
            </svg>
          </label>
          <ul
            tabIndex={0}
            className="overflowScroll menu menu-compact dropdown-content mt-3 p-4 gap-y-3 shadow bg-[#2D3B42] rounded-box w-52 z-50 text-white text-md font-semibold"
          >
            {sideBarNavigation.map((item, index) =>
              item[1] ? (
                <NestedSideButton
                  key={index}
                  index={index}
                  items={item}
                  phone={true}
                />
              ) : (
                <NavLink className="" to={item[0][1]} key={index}>
                  <span className="ml-5">{item[0][0]}</span>
                </NavLink>
              )
            )}
          </ul>
        </div>
      </div>
      <div className="navbar-center">
        {/* <a className="btn btn-ghost normal-case text-xl"></a> */}
      </div>
      <div className="navbar-end">
        <div className="dropdown dropdown-end  ">
          <div className="flex flex-col justify-center items-center">
            {" "}
            <label
              tabIndex={0}
              className="btn py-0 btn-ghost btn-circle avatar "
            >
              <div className="w-10 rounded-full">
                <img
                  src={
                    (role === "admin" && images[0]) ||
                    (role === "moderator" && images[1]) ||
                    (role === "viewer" && images[2])
                  }
                  alt={role + "image"}
                />
              </div>
            </label>
            <h2 className="text-white font-bold hidden lg:block">
              {firstName}
            </h2>
          </div>

          <ul
            tabIndex={0}
            className=" ml-[10rem]  p-2 shadow menu menu-compact dropdown-content  rounded-b-lg w-52 bg-[#2D3B42] text-white font-bold"
          >
            {role === "admin" && (
              <li>
                <NavLink to="/manage-users">Manage Users</NavLink>
              </li>
            )}
            <li>
              <button type="button" onClick={handleSignOut}>
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
